const ArrowsRotate = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M16.0515 16.875V14.1667C16.0515 13.8215 15.7717 13.5417 15.4265 13.5417H12.7182M3.95833 3.125L3.95833 5.83333C3.95833 6.17851 4.23816 6.45833 4.58333 6.45833H7.29167M3.17819 9.14063C3.14308 9.42215 3.125 9.70896 3.125 10C3.125 13.797 6.20304 16.875 10 16.875C12.2305 16.875 14.2593 15.8128 15.5268 14.1667M16.8218 10.8594C16.8569 10.5778 16.875 10.291 16.875 10C16.875 6.20304 13.797 3.125 10 3.125C7.76951 3.125 5.74073 4.18719 4.4732 5.83333"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default ArrowsRotate
